import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Path from 'routes/Path';
import { FreecodeLoading } from 'components/FreecodePage/FreecodeLoading/FreecodeLoading';
import FreecodePage from 'components/FreecodePage/FreecodePage';
import { editorTypes } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';
import { useFreecodeContextLayout } from 'hooks/useContext';
import FreecodeLayout from 'components/FreecodePage/FreecodeLayout/FreecodeLayout';
import SubmitFreecodeModal from 'components/Modals/FreecodeModals/SubmitFreecodeModal';
import useTestAutoSave from './useTestAutoSave';
import useTestRunFunction from './useTestRunFunction';
import useTestLoadFunction from './useTestLoadFunction';
import services from 'api/services';

const { TicketService } = services;

export default function FreecodeTest() {
  const { ticketId } = useParams();

  const { displaySubmit, setEditorType } = useFreecodeContextLayout();

  const { loading, error } = useTestLoadFunction(ticketId);

  useTestAutoSave();
  useTestRunFunction();

  useEffect(() => {
    setEditorType(editorTypes.freecode);
  }, [setEditorType]);

  useEffect(() => {
    if (!ticketId) return;

    const updateBlurTime = () => TicketService.updateAwayTime(ticketId, { event: 'blur' });

    const updateFocusTime = () => TicketService.updateAwayTime(ticketId, { event: 'focus' });

    window.addEventListener('focus', updateFocusTime);
    window.addEventListener('blur', updateBlurTime);

    return () => {
      window.removeEventListener('focus', updateFocusTime);
      window.removeEventListener('blur', updateBlurTime);
    };
  }, [ticketId]);

  return (
    <FreecodePage>
      <FreecodeLoading
        signInRequired
        loading={loading}
        errors={[error]}
        errorLinkText="All Tests"
        errorLink={Path.candidateTicketsPage}
      />
      {!loading && <FreecodeLayout />}
      {displaySubmit && <SubmitFreecodeModal />}
    </FreecodePage>
  );
}
